export default {
  loading: 'loading',
  loaded: 'loaded',
  error: 'error',
};
